import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { range } from 'lodash';

import styles from './shimmer.css';

class Shimmer extends Component {
  render() {
    const { value, full, className } = this.props;
    if (!value && !full) {
      return null;
    }
    let s = '';
    const cls = `${styles.shimmer} ${className}`;

    if (typeof (value) === 'number') {
      range(value).map(() => {
        s += 'x';
        return s;
      });
    } else if (typeof (value) === 'string') {
      s = value;
    } else if (!value && full) {
      s = (
        <span>&nbsp;</span>
      );
    }
    if (full) {
      return (
        <div className={cls}>
          {value}
        </div>
      );
    }
    return (
      <span className={cls}>
        {value}
      </span>
    );
  }
}

Shimmer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  full: PropTypes.bool,
  className: PropTypes.string,
};
Shimmer.defaultProps = {
  value: null,
  full: false,
  className: null,
};

export default Shimmer;
